import React, { Component } from 'react'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import NameUpdateUI from './NameUpdateUI.js'

class NameUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      firstName: this.props.firstName,
      lastName: this.props.lastName,
      firstNameError: null,
      lastNameError: null,
    }
  }

  render() {
    return (
      <NameUpdateUI
        context={this.props.context}
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        // text
        messageList={this.props.messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        // state
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel} // added in ViewOrUpdateUI
        setErrorList={this.setErrorList}
        onFirstNameChange={this.onFirstNameChange}
        onLastNameChange={this.onLastNameChange}
        setFirstNameError={this.setFirstNameError}
        setLastNameError={this.setLastNameError}
      />
    )
  }

  UNSAFE_componentWillMount() {
  }

  onFirstNameChange = (event) => {
    this.setState({firstName: event.target.value})
  }

  onLastNameChange = (event) => {
    this.setState({lastName: event.target.value})
  }

  setFirstNameError = (error) => {
    this.setState({firstNameError: error})
  }

  setLastNameError = (error) => {
    this.setState({lastNameError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    console.log('calling server')
    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      '/api/user/name',
      this.onSubmitCallback, {
        firstName: this.state.firstName,
        lastName: this.state.lastName
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'firstName':
            this.setFirstNameError(error.message)
            break;
          case 'lastName':
            this.setLastNameError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      this.props.onUpdateComplete(this.state.firstName, this.state.lastName)
      setTimeout(() => {
        this.props.onCancel()
      }, 2000);
    }
  }
}

export default NameUpdateSF
